import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'

import { vec2, vec3, mat4 } from 'gl-matrix'

import GEOM from '@/glxp/geom/plane'
import ShaderManifest from '../shaderManifest'
import { TweenMax } from "gsap";
class ShootingStar extends Rendable {
    constructor(scene) {
        super(scene)
        // console.log('PARTICLES')
        this.gl = scene.gl
        this.scene = scene

        this.node = new Node()
        this.node.position[2] = -1500
        this.node.position[1] = 1000
        this.node.position[0] = 1000

        this.shader = new Shader(ShaderManifest["shootingStar"])

        this.hasNormal = false
        this.onlyVertices = true

        this.count                  = 500
        this.wind                   = { x: 10, y: 10, z:0 }
        this.volumeCorner           = { x: -2000, y: 0, z: -200 }
        this.volumeSize             = { x: 4000, y: 3000, z: 10 }
        this.gravity                = 0
        this.timeScale              = 0
        this.time                   = 0
        this.particleSize           = 0.5
        this.fadeDistance           = 2
        this.opacity                = .7
        this.intensity              = 1
        this.noiseScale             = 0.005
        this.angle                  = -90
        this.progress               = 0

        this.particlesColor = vec3.fromValues(1, 0, 0)
        this.offset = vec3.create()

        this.vertices = this.createParticles()

        this.createAttribute("aSeed", "aSeed", 1, this.seeds)
        this.initBuffer({
            vertices: this.vertices,
        })

        this.initProgram(this.shader.vert, this.shader.frag)
        this.initVao()
        this.initMatrix()
        this.createUniforms()

        // let tween = TweenMax.fromTo(this, 1.5, {progress: 0, delay: 1, repeat: 90}, {progress: 1})
        // tween.repeat(-1)
    }

    createParticles() {
        let seed = 0
        let count = this.count
        this.seeds = []
        let vertices = []
        while (count--) {
            this.seeds.push(seed)
            vertices.push(Math.random() * this.volumeSize.x - this.volumeSize.x / 2)
            vertices.push(Math.random() * this.volumeSize.y - this.volumeSize.y / 2)
            vertices.push(Math.random() * this.volumeSize.z - this.volumeSize.z / 2)
            seed++
        }
        return vertices
    }

    createUniforms() {

        this.createUniform('uTexture', 'texture')

        this.createUniform('uVolumeCorner',     'float3')
        this.createUniform('uVolumeSize',       'float3')
        this.createUniform('uOffset',           'float3')
        this.createUniform('uParticleColor',    'float')
        // this.createUniform('uCount',    'float3')

        this.createUniform('uPixelRatio')
        this.createUniform('uPerlinIntensity')
        this.createUniform('uPerlinFrequency')
        this.createUniform('uTime')
        this.createUniform('uFadeDistance')
        this.createUniform('uParticleOpacity')
        this.createUniform('uParticleScale')
        this.createUniform('uAngle')
        this.createUniform('uProgress')


    }

    applyState() {
        let gl = this.gl

        this.scene.applyDefaultState()

        // gl.disable(gl.CULL_FACE)
        // gl.disable(gl.DEPTH_TEST)
        // gl.depthMask(false)
    }

    preRender() {
        this.time += this.scene.dt / 1000 * this.timeScale

        // this.offset[0] += this.wind.x * this.timeScale
        // this.offset[1] += this.wind.y * this.timeScale
        // this.offset[2] += this.wind.z * this.timeScale
        // this.offset[1] -= this.gravity * this.timeScale

    }

    shoot() {

    }

    render() {

        this.preRender()

        let gl = this.gl
        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture('Particle'))
        this.bindUniform('uTexture', 0)
        this.bindMatrixUniforms(this.scene.camera)

        this.bindUniform('uVolumeCorner', [this.volumeCorner.x, this.volumeCorner.y, this.volumeCorner.z])
        this.bindUniform('uVolumeSize', [this.volumeSize.x, this.volumeSize.y, this.volumeSize.z])
        this.bindUniform('uOffset', this.offset)
        this.bindUniform('uParticleColor', this.particlesColor)
        // this.bindUniform('uCount', this.count)
        this.bindUniform('uAngle', this.angle)
        this.bindUniform('uProgress', this.progress)

        this.bindUniform('uTime', this.time)
        this.bindUniform('uFadeDistance', this.fadeDistance)
        this.bindUniform('uParticleOpacity', this.opacity)
        this.bindUniform('uParticleScale', this.particleSize * this.scene.dpr)
        this.bindUniform('uPixelRatio', this.scene.dpr)
        this.bindUniform('uPerlinIntensity', this.intensity)
        this.bindUniform('uPerlinFrequency', this.noiseScale)
        gl.drawArrays(gl.POINT, 0, this.vertices.length/3);
        gl.bindVertexArray(null)

    }
}

export default ShootingStar
